import ConsolidatedReports from './component';
export const initialState = {};
export const component = ConsolidatedReports;
